const SINGLE_SELECT = 'SINGLE_SELECT';
const MULTI_SELECT = 'MULTI_SELECT';

export { SINGLE_SELECT, MULTI_SELECT };
